import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import moment from "moment";
import OutlinedText from "components/Input/OutlinedText/OutlinedText";
import CheckboxInput from "components/Input/CheckboxInput/CheckboxInput";
import Datepicker from "components/Input/Datepicker/Datepicker";
import s from "./ChangeContent.module.scss";

const ChangeContent = ({ handleInput, data }) => {
  const { t } = useTranslation();
  const [inputData, setInputData] = useState({
    updateBankAccount: false,
    settleDate: "",
  });
  const [focus, setFocus] = useState({});

  const textInputOnchange = (e, field, callback) => {
    let { value } = e.target;
    if (callback) {
      value = callback(value);
    }
    handleInput(value, field);
  };
  const textInputOnFocus = (field) => {
    setFocus({ [field]: true });
  };
  const textInputOnBlur = (field) => {
    setFocus({ [field]: false });
  };

  const updateBankAccountOnChange = (e) => {
    const { checked } = e.target;
    setInputData({ ...inputData, updateBankAccount: checked });
    handleInput(checked, "updateBankAccount");
  };

  const settleDateOnChange = (e, type) => {
    const rawDate = JSON.parse(JSON.stringify(e));
    const date = moment(rawDate).isValid()
      ? moment(rawDate).format("YYYY-MM-DD")
      : e !== null
      ? ""
      : null;
    if (type === "start") {
      setInputData({ ...inputData, settleDate: date });
      handleInput(date, "settleDate");
    }
  };

  return (
    <div className={s.contentContainer}>
      <div>
        <OutlinedText
          label={t(
            "page.finance.settlement.plan.all.change.function.dialog.content.1",
          )}
          mandatory
          noErrorMessage
          defaultValue={data.adjustAmount ? data.adjustAmount : 0}
          onchangeFn={(e) => textInputOnchange(e, "adjustAmount")}
          onfocusFn={() => textInputOnFocus("adjustAmount")}
          onblurFn={() => textInputOnBlur("adjustAmount")}
          sxParams={{ textFocus: focus.adjustAmount }}
        />
      </div>

      <div>
        <CheckboxInput
          label={t(
            "page.finance.settlement.plan.all.change.function.dialog.content.2",
          )}
          oncheckFn={(e) => updateBankAccountOnChange(e)}
          checked={inputData.updateBankAccount}
        />
      </div>

      <div>
        <Datepicker
          label={t(
            "page.finance.settlement.plan.all.change.function.dialog.content.3",
          )}
          mandatory
          type="start"
          noErrorMessage
          defaultValue={data.settleDate ? dayjs(data.settleDate) : ""}
          onchangeFn={settleDateOnChange}
          onfocusFn={() => textInputOnFocus("settleDate")}
          onblurFn={() => textInputOnBlur("settleDate")}
          sxParams={{ datepickerFocus: focus.settleDate }}
        />
      </div>

      <div>
        <OutlinedText
          label={t(
            "page.finance.settlement.plan.all.change.function.dialog.content.4",
          )}
          mandatory
          noErrorMessage
          defaultValue={data.changeReason ? data.changeReason : ""}
          onchangeFn={(e) => textInputOnchange(e, "changeReason")}
          onfocusFn={() => textInputOnFocus("changeReason")}
          onblurFn={() => textInputOnBlur("changeReason")}
          sxParams={{ textFocus: focus.changeReason }}
        />
      </div>
    </div>
  );
};

export default React.memo(ChangeContent);
